import React, { useEffect, useState } from 'react'
import CustomRow from '../../reusable-components/CustomRow'
import { Col } from 'antd'
import AgiliteSkeleton from '../../reusable-components/AgiliteSkeleton'
import { readClinicDataPoints } from '../../Super-Admin/Data Points/data-points-utils/data-point-utils'
import { readCarePlanTemplates } from '../utils/utils'
import store from '../../../store'
import PatientEnrollment from './PatientEnrollment'
import PlanTemplateForm from './PlanTemplateForm'

// This will be imported from a central registry in production
const getPlanListComponent = (planType) => {
  // For now, we'll pretend we're importing dynamically
  // This should use PlansList (for templates) instead of PatientPlansList
  return require('./PlansList').default
}

const PlanManagement = ({ isMonitoring, planType, planLabel }) => {
  // State
  const [planTemplatesLoading, setPlanTemplatesLoading] = useState(false)
  const [currentTemplate, setCurrentTemplate] = useState(null)
  const [dataPoints, setDataPoints] = useState([])

  // Loading
  const [planTemplates, setPlanTemplates] = useState([])
  const [dataPointsLoading, setDataPointsLoading] = useState(false)

  // Dynamically get the PlansList component based on planType
  const PlansList = getPlanListComponent(planType)

  useEffect(() => {
    handleReadPlanTemplates()
    handleReadDataPoints()
    // eslint-disable-next-line
  }, [])

  const handleReadDataPoints = async () => {
    let tmpDataPoints = []

    setDataPointsLoading(true)
    try {
      tmpDataPoints = await readClinicDataPoints()
      setDataPoints(tmpDataPoints)
    } catch (e) {}
    setDataPointsLoading(false)
  }

  const handleReadPlanTemplates = async () => {
    let tmpData = []

    setPlanTemplatesLoading(true)
    try {
      // Here we would use dynamic endpoints based on planType
      // For now, we're using the existing function but in production
      // this would use a registry of endpoints
      tmpData = await readCarePlanTemplates({
        createdBy: store.getState().auth.agiliteUser._id,
        planType: planType
      })

      setPlanTemplates(tmpData)
    } catch (e) {}
    setPlanTemplatesLoading(false)
  }

  const handleEnrollmentView = (templateProps) => {
    setCurrentTemplate(templateProps)
  }

  return (
    <>
      <CustomRow>
        {dataPointsLoading || planTemplatesLoading ? (
          <Col span={24}>
            <AgiliteSkeleton skActive spinnerTip='Loading...' />
          </Col>
        ) : (
          <Col span={24}>
            {!currentTemplate ? (
              <PlansList
                isMonitoring={isMonitoring}
                handleEnrollmentView={handleEnrollmentView}
                dataPoints={dataPoints}
                planTemplates={planTemplates}
                refreshView={handleReadPlanTemplates}
                planType={planType}
                planLabel={planLabel}
              />
            ) : undefined}
            {currentTemplate ? (
              <PatientEnrollment
                isMonitoring={isMonitoring}
                setCurrentTemplate={setCurrentTemplate}
                template={currentTemplate}
                planType={planType}
                planLabel={planLabel}
              />
            ) : undefined}
          </Col>
        )}
      </CustomRow>
    </>
  )
}

export default PlanManagement
